import useEventGenericV2 from './use-event-generic'

export default (eventParams = []) => {
  return eventParams.map(eventParam => useEventGenericV2({
    eventParam,
    isInitialiser: false
  }))
}
